import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { useTranslationWithNamespace } from '../../hooks/useTranslationWithNamespace';

interface CopyToClipboardProps {
  text: string;
  disabled?: boolean;
}

/**
 * Component for copying text to clipboard
 */
const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ text, disabled = false }) => {
  const { t } = useTranslationWithNamespace('common');
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!text || disabled) return;
    
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      },
      (err) => {
        console.error('Could not copy text: ', err);
      }
    );
  };

  return (
    <Tooltip title={copied ? t('copied', 'Copied!') : t('copy', 'Copy to clipboard')}>
      <Button
        type="text"
        size="small"
        icon={copied ? <CheckOutlined /> : <CopyOutlined />}
        onClick={handleCopy}
        disabled={!text || disabled}
        style={{ color: copied ? '#52c41a' : undefined }}
      />
    </Tooltip>
  );
};

export default CopyToClipboard;
